export default "__VITE_ASSET__etlZzfE1__"